import { render, staticRenderFns } from "./v-select.vue?vue&type=template&id=f6127db6&scoped=true&"
import script from "./v-select.vue?vue&type=script&lang=js&"
export * from "./v-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6127db6",
  null
  
)

export default component.exports